import { fetchData } from '../utils/fetchData';
import { RESOURCES, API_BASE_URL } from '../utils/constants/constants';

const QUICK_QUERY_RESOURCES = RESOURCES.quickQuery;

export default function getDisplayBundle(productId, reportTypeId) {
  const resource = `${API_BASE_URL}${QUICK_QUERY_RESOURCES.displayBundle}/${productId}/${reportTypeId}`;
  return fetchData(resource);
}
